module.exports = __webpack_public_path__ + "img/ThunderstormOutlined.9c3aecfd.svg";